export const exportURLs = {
  individualProperty_members: "above-property/members/export",
  individualProperty_plans: "above-property/plans/export",
  corp_properties: "view/properties/summary/export",
  corp_plans: "view/plans/summary/export",
  admin_console: "corporate/permissions/export",
  feedback: "plans/feedback/export"
};
